import React, { useEffect, useState, useRef } from 'react';
import {
    Link
} from "react-router-dom";
import axios from 'axios';
import dayjs from "dayjs";
import Calendar from '../../../components/calendar/Calendar.js';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import CanvasJSReact_ChartPerformance from '../../../components/chart/ChartPerformanceOverall.js';

function HistoricalCentralOverallTrack(props) {
    let ismount = useRef(true);
    let isfirst = useRef(true);
    let response_key = useRef('data_day');

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const [reporttype_picker, setReporttype_picker] = useState('day');
    const [reporttype, setReporttype] = useState('daily');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));
    const [reportselected, setReportselected] = useState('Daily');
    const [calendar_text, setCalendar_text] = useState('Date');

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [dashboard_tabs, setDashboard_tabs] = useState('energy');
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const [plot_color, setPlot_color] = useState([])
    const [group_handle, setGroup_handle] = useState([])
    const [chart_raw, setChart_raw] = useState({})
    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Energy: [],
        PR: [],
        PRG: [],
        ORx: [],
        ORG: [],
        ENS: [],
        Saving: [],
        Value: [],
        CO2: [],
        CODData: null,
        Chart1_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart2_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart3_Style: { height: 235, unit: "%", digit: 2, type: "line", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart4_Style: { height: 235, unit: "kWh", digit: 3, type: "column", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart5_Style: { height: 235, unit: "kgCO2", digit: 3, type: "column", axis_y1: 'CO2 (kgCO2)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart6_Style: { height: 235, unit: "THB", digit: 3, type: "column", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        Chart7_Style: { unit: "THB", digit: 3, type: "column", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null },
        summary: { Energy: 0, PRx: 0, ORx: 0, ENS: 0, Saving: 0, Value: 0, CO2: 0 },
        summary_unit: { Energy: "-", PRx: "-", ORx: "-", ENS: "-", Saving: "-", Value: "-", CO2: "-", },
        co2_factor: [],
        sum_time: [],
        chart_box: []
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };

    useEffect(() => {
        if (isfirst.current) {
            isfirst.current = false
            api_get_dashboard()
        }
    }, []);

    useEffect(() => {
        if (reporttype !== undefined) {
            if (reporttype === "daily") {
                setReporttype_picker("date")
                setCalendar_text("Date")
            } else if (reporttype === "monthly") {
                setReporttype_picker("month")
                setCalendar_text("Month")
            } else if (reporttype === "yearly") {
                setReporttype_picker("year")
                setCalendar_text("Year")
            } else if (reporttype === "cod") {
                setReporttype_picker("month")
            }
        }
    }, [reporttype]);

    function disabledCalendar(current) {
        if (reporttype === "daily") {
            return current.isBefore(props.permitdata.cod_date, 'day') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'day')
        } else if (reporttype === "monthly") {
            return current.isBefore(props.permitdata.cod_date, 'month') || current.isAfter(dayjs(new Date()).subtract(1, 'days').format("YYYY-MM-DD 23:59:59"), 'month')
        } else if (reporttype === "yearly") {
            return current.isBefore(props.permitdata.cod_date, 'year') || current.isAfter(dayjs(new Date()).format("YYYY-MM-DD 23:59:59"), 'year')
        }
    }

    useEffect(() => {
        return () => {
            ismount.current = false
            setChart_plot({})
            setChart_raw({})
            setPlot_color([])
        };
    }, []);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        var daplot = {
            XLabel: 'ccc',
            Energy: [[], [], [], []],
            PR: [[], [], [], []],
            PRG: [],
            ORx: [[], [], [], []],
            ORG: [],
            ENS: [[], [], [], []],
            Saving: [[], [], [], []],
            Value: [[], [], [], []],
            CO2: [[], [], [], []],
            CODData: null,
            Chart1_Style: {},
            Chart2_Style: {},
            Chart3_Style: {},
            Chart4_Style: {},
            Chart5_Style: {},
            Chart6_Style: {},
            Chart7_Style: {},
            co2_factor: [],
            sum_time: [],
            chart_box: []
        }
        var demo_chart = chart_raw
        if (reporttype === "daily") {
            daplot.Chart1_Style = { height: 235, unit: "kWh", digit: 2, type: "stackedColumn", axis_y1: 'Solar Energy (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "kWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (kWh)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart5_Style = { height: 235, unit: "kgCO<sub>2</sub>", digit: 2, type: "stackedColumn", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'horizontal', start: null }
            daplot.CODData = null
        } else if (reporttype === "monthly") {
            daplot.Chart1_Style = { height: 235, unit: "kWh", digit: 2, type: "stackedColumn", axis_y1: 'Solar Energy (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "kWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (kWh)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart5_Style = { height: 235, unit: "kgCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (kgCO2)', xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'day', xformat: 'DD', yformat: '#0.###,.k', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical', start: null }
        } else if (reporttype === "yearly") {
            daplot.Chart1_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Solar Energy (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (MWh)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart5_Style = { height: 235, unit: "TonCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (TonCO2)', xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.,.M', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'month', xformat: 'MMM', yformat: '#0.###,.,.M', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical', start: null }
            //  daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
        } else if (reporttype === "cod") {
            daplot.Chart1_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Solar Energy (MWh)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart2_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Performance Ratio (%)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart3_Style = { height: 235, unit: "%", digit: 2, type: "spline", axis_y1: 'Operation Ratio (%)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null, ispercent: true }
            daplot.Chart4_Style = { height: 235, unit: "MWh", digit: 3, type: "stackedColumn", axis_y1: 'Energy not Supply (MWh)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart5_Style = { height: 235, unit: "TonCO<sub>2</sub>", digit: 3, type: "stackedColumn", axis_y1: 'CO2 Reduction (TonCO2)', xinterval: 'year', xformat: 'YYYY', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart6_Style = { height: 235, unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Saving (THB)', xinterval: 'year', xformat: 'YYYY', yformat: '#0.###,.,.M', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
            daplot.Chart7_Style = { unit: "THB", digit: 2, type: "stackedColumn", axis_y1: 'Energy Value (THB)', xinterval: 'year', xformat: 'YYYY', yformat: '#0.###,.,.M', tooltip_header: 'Year', tooltip_format: 'YYYY', indexlabel: 'vertical', start: null }
            //  daplot.CODData = { CODIndex_Start: response.data.plot.CODData.CODIndex_Start, CODIndex_Stop: response.data.plot.CODData.CODIndex_Stop }
        }
        if (demo_chart.chart !== null && demo_chart.chart !== undefined) {
            var lock = false
            daplot.XLabel = demo_chart.xlabel
            daplot.sum_time = demo_chart.sum_time
            daplot.chart_box = demo_chart.chart_box
            if (reporttype === "cod") {
                daplot.unit_rate = undefined
            }
            daplot.co2_factor = demo_chart.factor_co2
            for (let gp = 0; gp < 4; gp++) {
                if (demo_chart.chart[gp] !== null && demo_chart.chart[gp] !== undefined) {
                    if (!lock) {
                        daplot.Chart2_Style.start = new Date(demo_chart.chart[gp][0].x)
                        daplot.Chart3_Style.start = new Date(demo_chart.chart[gp][0].x)
                        lock = true
                    }
                    daplot.PRG = []
                    daplot.ORG = []
                    for (let i = 0; i < demo_chart.chart[gp].length; i++) {
                        const dx = new Date(demo_chart.chart[gp][i].x)

                        const tm1_energy = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['solar'],
                        }
                        const tm_pr = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['pr_ens']
                        }
                        const tm_prg = {
                            x: dx,
                            y: daplot.sum_time[i]['PRG']
                        }
                        const tm_or = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['orx_ens']
                        }
                        const tm_org = {
                            x: dx,
                            y: daplot.sum_time[i]['ORG']
                        }
                        const tm_ens = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['ens']
                        }
                        const tm_save = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['saving']
                        }
                        const tm_value = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['value']
                        }
                        const tm_co2 = {
                            x: dx,
                            y: demo_chart.chart[gp][i]['co2']
                        }
                        daplot.Energy[gp].push(tm1_energy)
                        daplot.PR[gp].push(tm_pr)
                        daplot.PRG.push(tm_prg)
                        daplot.ORx[gp].push(tm_or)
                        daplot.ORG.push(tm_org)
                        daplot.ENS[gp].push(tm_ens)
                        daplot.Saving[gp].push(tm_save)
                        daplot.Value[gp].push(tm_value)
                        daplot.CO2[gp].push(tm_co2)
                    }
                }
            }

            setChart_plot({
                ...chart_plot,
                XLabel: daplot.XLabel,
                Energy: daplot.Energy,
                PR: daplot.PR,
                PRG: daplot.PRG,
                ORx: daplot.ORx,
                ORG: daplot.ORG,
                ENS: daplot.ENS,
                Saving: daplot.Saving,
                Value: daplot.Value,
                CO2: daplot.CO2,
                CODData: daplot.CODData,
                Chart1_Style: daplot.Chart1_Style,
                Chart2_Style: daplot.Chart2_Style,
                Chart3_Style: daplot.Chart3_Style,
                Chart4_Style: daplot.Chart4_Style,
                Chart5_Style: daplot.Chart5_Style,
                Chart6_Style: daplot.Chart6_Style,
                Chart7_Style: daplot.Chart7_Style,
                summary: {
                    Energy: demo_chart.sum_total.Energy,
                    PRx: demo_chart.sum_total.PR,
                    ORx: demo_chart.sum_total.ORx,
                    ENS: demo_chart.sum_total.ENS,
                    Saving: demo_chart.sum_total.Saving,
                    Value: demo_chart.sum_total.Value,
                    CO2: demo_chart.sum_total.CO2,
                },
                summary_unit: {
                    Energy: getUnit(demo_chart.sum_unit, 'sum_energy'),
                    PRx: getUnit(demo_chart.sum_unit, 'pr_ens'),
                    ORx: getUnit(demo_chart.sum_unit, 'orx_ens'),
                    ENS: getUnit(demo_chart.sum_unit, 'sum_ens'),
                    Saving: getUnit(demo_chart.sum_unit, 'sum_saving'),
                    Value: getUnit(demo_chart.sum_unit, 'sum_value'),
                    CO2: getUnit(demo_chart.sum_unit, 'sum_co2'),
                },
                co2_factor: daplot.co2_factor,
                sum_time: daplot.sum_time,
                chart_box: daplot.chart_box
            })
        }
    }, [chart_raw]);

    function getUnit(data, tag) {
        if (data !== null) {
            return data[tag]
        }
        return ""
    }

    async function api_get_dashboard() {
        setmodal_load({ enable: true, message: "Loading overall history data.." })
        await sleep(300)
        setChart_raw({})

        var dt = ""
        if (reporttype === "daily") {
            response_key.current = "data_day"
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD")
        } else if (reporttype === "monthly") {
            response_key.current = "data_month"
            dt = dayjs(new Date(reportdate_dt)).format("YYYY-MM")
        } else if (reporttype === "yearly") {
            response_key.current = "data_year"
            dt = dayjs(new Date(reportdate_dt)).format("YYYY")
        } else if (reporttype === "cod") {
            response_key.current = "data_cod"
            dt = dayjs(new Date(reportdate_dt)).format("YYYY")
        }
        const formData = new FormData()
        formData.append('sitelist', props.permitdata.sitescope_str)
        formData.append('reporttype', reporttype)
        formData.append('reportdate', dt)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/central/overall", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (ismount.current) {
                    if (response.data.status === 'OK') {
                        if (response.data.group_handle !== undefined) {
                            setGroup_handle(response.data.group_handle)
                        }
                        if (response.data[response_key.current] !== undefined) {
                            setChart_raw(response.data[response_key.current])
                        }
                        if (response.data.plot_color !== undefined) {
                            setPlot_color(response.data.plot_color)
                        }
                        setReportselected(convert_reporttype_upper())

                    }
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
            });
    }

    function convert_reporttype_upper() {
        if (reporttype === "daily") {
            return "Daily"
        } else if (reporttype === "monthly") {
            return "Monthly"
        } else if (reporttype === "yearly") {
            return "Yearly"
        } else if (reporttype === "cod") {
            return "COD"
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <h4 className="mb-1"><i className="mdi mdi-table-search color-orange"></i> Overall History Track</h4>
                            <p className="mb-0">Tracking your performace data with overall summary charts.</p>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-2 print-disable">
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Type</label>
                            <select id="reporttype" name="reporttype" className="form-select" value={reporttype} onChange={(e) => {
                                setReporttype(e.target.value)
                            }} required>
                                <option value="daily">Daily</option>
                                <option value="monthly">Monthly</option>
                                <option value="yearly">Yearly</option>
                                <option value="cod">From COD</option>
                            </select>
                        </div>
                        <div className={reporttype !== "cod" ? "d-block " : "d-none"} style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select {calendar_text}</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange}
                                picker={reporttype_picker}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt}
                                disabledDate={disabledCalendar}
                            />
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_get_dashboard() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                        </div>
                    </div>

                    <div className="overall-ui d-block d-xxl-flex">
                        <div className='chart-area'>
                            <div className="card card-common card-overall2">
                                <div className="card-body pb-3">
                                    <div className='d-block d-sm-flex justify-content-sm-between w-100 card-overall-chart-header pb-1'>
                                        <div className='card-overall-header-wrapper d-block mb-1 mb-md-0'>
                                            <h5 className='mb-0'><i className="mdi mdi-chart-line"></i> Business Overall {reportselected} Chart</h5>
                                            <h6 className='card-overall-header-subtitle'>Data of current day are not included in monthly and yearly charts.</h6>
                                        </div>
                                    </div>
                                    <div className="toolbar-end px-2 mb-4 mt-1">
                                        <ul className="nav nav-tabs card-header-tabs">
                                            <li className="nav-item">
                                                <Link className={"nav-link" + (dashboard_tabs === "energy" ? " show active" : "")} onClick={() => { setDashboard_tabs("energy") }}>Energy & Performance</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className={"nav-link" + (dashboard_tabs === "operation" ? " show active" : "")} onClick={() => { setDashboard_tabs("operation") }} >Operation & ENS</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className={"nav-link" + (dashboard_tabs === "co2" ? " show active" : "")} onClick={() => { setDashboard_tabs("co2") }}>CO2 & Saving</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className={"nav-link" + (dashboard_tabs === "value" ? " show active" : "")} onClick={() => { setDashboard_tabs("value") }}>Energy Value</Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className={'tabs-content' + (dashboard_tabs === "energy" ? " " : " d-none")}>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Solar Energy</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Energy}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_energy}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Energy}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_energy}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'Energy'}
                                                plotdata={chart_plot.Energy}
                                                chart_style={chart_plot.Chart1_Style}
                                                cod={chart_plot.CODData}
                                                max={null}
                                                interval={null}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Performance Ratio</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.PRx}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_pr}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.PRx}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_pr}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'PR'}
                                                plotdata={chart_plot.PR}
                                                plotcolor2="#E94646"
                                                plotname2="PR Guarantee"
                                                plotdata2={chart_plot.PRG}
                                                chart_style={chart_plot.Chart2_Style}
                                                cod={chart_plot.CODData}
                                                max={120}
                                                interval={20}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                    </div>
                                    <div className={'tabs-content' + (dashboard_tabs === "operation" ? " " : " d-none")}>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Operation Ratio</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.ORx}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_or}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.ORx}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_or}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'ORx'}
                                                plotdata={chart_plot.ORx}
                                                plotcolor2="#E94646"
                                                plotname2="OR Guarantee"
                                                plotdata2={chart_plot.ORG}
                                                chart_style={chart_plot.Chart3_Style}
                                                cod={chart_plot.CODData}
                                                max={120}
                                                interval={20}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Energy Not Supply</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.ENS}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_ens}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.ENS}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_ens}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'ENS'}
                                                plotdata={chart_plot.ENS}
                                                chart_style={chart_plot.Chart4_Style}
                                                cod={chart_plot.CODData}
                                                max={null}
                                                interval={null}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                    </div>
                                    <div className={'tabs-content' + (dashboard_tabs === "co2" ? " " : " d-none")}>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">CO<sub>2</sub></h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.CO2}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_co2}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.CO2}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_co2}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'CO2'}
                                                plotdata={chart_plot.CO2}
                                                chart_style={chart_plot.Chart5_Style}
                                                cod={chart_plot.CODData}
                                                max={null}
                                                interval={null}
                                                co2factor={chart_plot.co2_factor}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Estimate Saving</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Saving}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_saving}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Saving}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_saving}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'Saving'}
                                                plotdata={chart_plot.Saving}
                                                chart_style={chart_plot.Chart6_Style}
                                                cod={chart_plot.CODData}
                                                max={null}
                                                interval={null}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                    </div>
                                    <div className={'tabs-content' + (dashboard_tabs === "value" ? " " : " d-none")}>
                                        <div className='chart-box'>
                                            <h6 className="card-title font-weight-bold mb-0">Estimate Energy Value</h6>
                                            <div className='d-none d-sm-flex flex-wrap gap-2 py-2'>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='overall-chart-boxs' key={index}>
                                                            <h6>{data.header !== "Total" ? <i className='mdi mdi-rectangle' style={{ color: data.color }}></i> : null} {data.header}</h6>
                                                            <div className='overall-chart-subtable'>
                                                                <div className='overall-chart-cell'>{chart_plot.summary_unit.Value}</div>
                                                                <div className='overall-chart-cell cell-value'>{data.value_eval}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className='chart-box-table mt-2 mb-3 border-bottom d-sm-none'>
                                                <div className='chart-box-table-row'>
                                                    <div className='chart-box-table-cell border-bottom'>Business Group</div>
                                                    <div className='chart-box-table-cell font-right border-bottom'>{chart_plot.summary_unit.Value}</div>
                                                </div>
                                                {
                                                    chart_plot.chart_box.map((data, index) => (
                                                        <div className='chart-box-table-row' key={index}>
                                                            <div className='chart-box-table-cell'>
                                                                {
                                                                    data.header !== "Total" ?
                                                                        <div className='chart-box-table-cell'><i className='mdi mdi-rectangle' style={{ color: data.color }}></i> {data.header}</div>
                                                                        :
                                                                        <>{data.header}</>
                                                                }
                                                            </div>
                                                            <div className='chart-box-table-cell font-right font-sarabun text-dark'>{data.value_eval}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <CanvasJSReact_ChartPerformance
                                                xlabel={chart_plot.XLabel}
                                                sum_time={chart_plot.sum_time}
                                                sum_code={'Value'}
                                                plotdata={chart_plot.Value}
                                                chart_style={chart_plot.Chart7_Style}
                                                cod={chart_plot.CODData}
                                                max={null}
                                                interval={null}
                                                group_handle={group_handle}
                                                plot_color={plot_color}
                                            ></CanvasJSReact_ChartPerformance>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalCentralOverallTrack